import React from "react";
import ReceiptComponent from "../result/receipt/Receipt.jsx";
import { utils } from "../../utils/Utils.jsx";
import "./printPDF.css";

const PrintPDFComponent = (props) => {
  /* Tenant-aware branding. White-label deploys must show the
     customer's company brand, not the platform brand. Source order:
       1. Backend config (canonical, per logged-in tenant)
       2. Build-time env vars (deploy-time fallback)
       3. Empty/blank — better to show nothing than the wrong brand
     The legacy hardcoded "16192 Coastal Hwy..." Bloxcross address
     and "support@bloxcross.com" are removed; tenants supply their
     own via REACT_APP_COMPANY_ADDRESS / REACT_APP_COMPANY_SUPPORT_EMAIL,
     or backend config.company_address / company_support_email. */
  const companyName =
    props.config?.company_display_name ||
    process.env.REACT_APP_COMPANY_NAME ||
    "";
  const companyTitle =
    props.config?.company_display_name ||
    process.env.REACT_APP_TITLE ||
    process.env.REACT_APP_COMPANY_NAME ||
    "";
  const companyAddress =
    props.config?.company_address ||
    process.env.REACT_APP_COMPANY_ADDRESS ||
    "";
  const companySupportEmail =
    props.config?.company_support_email ||
    process.env.REACT_APP_COMPANY_SUPPORT_EMAIL ||
    "";

  const handleClick = () => {
    utils.goToURL(this.props, "/dashboard");
  };

  return (
    <div class="payment-detail-inner-div">
      <div className="payment-detail-company-header">
        {/* /themes/light/logo.png is per-tenant: each Amplify deploy
            ships its own asset under that path. */}
        <img
          className="print-img"
          src={"/themes/light/logo.png"}
          alt={companyName ? companyName + " logo" : "Company logo"}
        />
        {companyTitle && (
          <div className="company-title">{companyTitle}</div>
        )}
      </div>
      <div className="payment-detail-title">{props.title}</div>

      {props.receiptData ? (
        <ReceiptComponent data={props.receiptData} />
      ) : (
        <props.bankDetails></props.bankDetails>
      )}

      <div class="payment-detail-info">
        <div class="partial-border"></div>
        <div class="info-row">
          {
            props.localizedText[
              "this-reference-can-be-provided-to-the-recipients-financial"
            ]
          }
        </div>
        <div class="info-row">
          {props.localizedText["receipt-created-on"]}
          {utils.formatDateUSWithTime(new Date().toISOString())}
        </div>
      </div>
      <div class="payment-detail-company-footer">
        {companyName && <div class="legal-name">{companyName}</div>}
        {(companyAddress || companySupportEmail) && (
          <div class="bottom-info-div">
            {companyAddress && (
              <div
                class={"bottom-info" + (companySupportEmail ? " right-pipe" : "")}
              >
                {companyAddress}
              </div>
            )}
            {companySupportEmail && (
              <div class="bottom-info">{companySupportEmail}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrintPDFComponent;
